import { useCallback, useState } from 'react';

export const initialOrderValues = {
  name: '',
  email: '',
  phone: '',
  fulfillment: 'pickup',
  address: '',
  notes: '',
};

const validateOrder = values => {
  const errors = {};

  if (!values.name.trim()) errors.name = 'Please enter your name.';
  if (!values.email.trim()) {
    errors.email = 'Please enter your email.';
  } else if (!/^\S+@\S+\.\S+$/.test(values.email)) {
    errors.email = 'Please enter a valid email.';
  }
  if (!values.phone.trim()) errors.phone = 'Please enter your phone number.';
  if (values.fulfillment === 'delivery' && !values.address.trim()) {
    errors.address = 'Please enter a delivery address.';
  }

  return errors;
};

const useOrderForm = (onSubmit, initialValues = initialOrderValues) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback(event => {
    const { name, value } = event.target;

    setValues(currentValues => ({ ...currentValues, [name]: value }));
    setErrors(currentErrors => ({ ...currentErrors, [name]: '' }));
  }, []);

  const handleSubmit = useCallback(event => {
    event.preventDefault();
    const nextErrors = validateOrder(values);
    setErrors(nextErrors);

    if (Object.keys(nextErrors).length === 0) {
      onSubmit(values);
    }
  }, [onSubmit, values]);

  return { values, errors, handleChange, handleSubmit };
};

export default useOrderForm;
